import { Button, Modal, ModalProps } from 'react-bootstrap';

import React from 'react';
import classNames from 'classnames';

interface IConfirmModalProps extends ModalProps {
  cancelButton?: React.ReactNode;
  confirmButton?: React.ReactNode;
  content?: React.ReactNode;
  secondContent?: React.ReactNode;
  header?: React.ReactNode;
  headerIcon?: React.ReactNode;
  onCancel?: () => void;
  onConfirm: () => void;
  show: boolean;
  bodyClassName?: string;
  modalClassName?: string;
}

export default function ConfirmModal({
  cancelButton,
  confirmButton,
  variantConfirmButton,
  content,
  secondContent,
  header,
  onCancel,
  onConfirm,
  show,
  headerIcon,
  bodyClassName,
  modalClassName,
  ...remaining
}: IConfirmModalProps) {
  return (
    <Modal show={show} {...remaining} className={modalClassName}>
      {header ? (
        <Modal.Header className="justify-content-start">
          {headerIcon ? headerIcon : null}
          <Modal.Title>{header}</Modal.Title>
        </Modal.Header>
      ) : null}

      <Modal.Body className={classNames('content-popup', bodyClassName)}>
        {content}
        {secondContent && <div className="mt-3">{secondContent}</div>}
      </Modal.Body>

      <Modal.Footer className="content-popup">
        {onCancel && (
          <Button
            className="me-2 style-btn-outline"
            variant={`outline-${variantConfirmButton}`}
            onClick={onCancel}>
            {cancelButton}
          </Button>
        )}
        <Button
          className="ms-2 style-btn"
          variant={variantConfirmButton}
          onClick={onConfirm}>
          {confirmButton}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
ConfirmModal.defaultProps = {
  cancelButton: 'Cancel',
  confirmButton: 'OK',
  content: 'Are you sure?',
  header: 'Confirmation',
  variantConfirmButton: 'primary'
};
